import { ApiProject, ApiSyncType, ApiUTMEntity } from "@incendium/api";
import { syncService } from "Apis";
import { listUtmEntities } from "features/dataConnectors/services/utmEntities";
import { useProjectSharedState } from "Hooks/useSharedState";

const fetchMetaUtmEntites = async (project: ApiProject) => {
  const res = await syncService.syncServiceListSyncs({
    projectId: project.id as number,
  });
  const metaSync = (res.results || []).find(
    (es) => es.type === ApiSyncType.FACEBOOK_ADS,
  );
  if (metaSync) {
    return await listUtmEntities(project.id, metaSync.id);
  }
  return [];
};

export const useMetaUtmEntites = () => {
  const { state, setState, refetch, loading, fetched } = useProjectSharedState<
    ApiUTMEntity[]
  >("metaUtmEntites", [], fetchMetaUtmEntites);

  return {
    entites: state,
    setEntites: setState,
    refetchEntites: refetch,
    loading,
    fetched,
  };
};
